import { PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { payrollStore } from '../../stores';
import { ReviewPayroll } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import { toJS } from 'mobx';

const ReviewPayrollContainer = ({ closeModal, requester, action }) => {
	const [viewBreakdown, setViewBreakdown] = useState(false);
	const [loading, setLoading] = useState(false);
	const showPayrollBreakdown = () => {
		setViewBreakdown(true);
	};
	const validationSchema = () => {
		return object({
			comment: string().required('Please enter comment'),
			action: string().required('Please select an action'),
		});
	};

	const onSubmit = async payload => {
		let controller = '';
		setLoading(true);
		if (
			action === constant.STATUS.VOID &&
			payload.userType === constant.MakerCheckerUserType.REQUESTER
		) {
			controller = 'setVoid';
		} else if (payload.action === constant.STATUS.REQUEST_CHANGE) {
			if (payload.userType === constant.MakerCheckerUserType.REVIEWER) {
				controller = 'reviewerBulkRequestChange';
			}
			if (payload.userType === constant.MakerCheckerUserType.APPROVER) {
				controller = 'approverBulkRequestChange';
			}
		} else {
			if (payload.userType === constant.MakerCheckerUserType.REQUESTER) {
				controller = 'requestReview';
			}
			if (payload.userType === constant.MakerCheckerUserType.REVIEWER) {
				controller = 'requestApproval';
			}
			if (payload.userType === constant.MakerCheckerUserType.APPROVER) {
				controller = 'approve';
			}
		}

		const { status, errorMessage } = await PayrollController[controller]({
			comment: payload.comment,
			tag: payload.tag,
		});
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		MimaToastUtil.error({
			message: errorMessage,
		});
		return closeModal();
	};

	return (
		<ReviewPayroll
			closeModal={closeModal}
			action={action}
			payrollSummary={payrollStore.payrollSummaries?.[0] || null}
			tag={localStorage.getItem('tagValue')}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			tags={toJS(payrollStore.tags)}
			viewBreakdown={viewBreakdown}
			showPayrollBreakdown={showPayrollBreakdown}
			loading={loading}
			requester={requester}
		/>
	);
};

export default observer(ReviewPayrollContainer);
